import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-task-due-date',
  template: `
    <div class="d-flex align-items-center">
      <span [class.text-danger]="isOverdue" [class.fw-bold]="isOverdue">
        {{ date }}
      </span>
      <span *ngIf="showDDay && dDayBadge" class="badge ml-2" [ngClass]="dDayClass">
        {{ dDayBadge }}
      </span>
      <i *ngIf="isOverdue" class="ft-alert-circle text-danger ml-2" title="Overdue"></i>
    </div>
  `
})
export class TaskDueDateComponent implements OnChanges {
  @Input() date: string = ''; // YYYY-MM-DD
  @Input() completionStatus: string = 'todo'; // 'todo', 'done', 'confirmed'
  @Input() showDDay: boolean = true;

  isOverdue: boolean = false;
  dDayBadge: string = '';
  dDayClass: string = 'bg-secondary';

  ngOnChanges(): void {
    this.calculate();
  }

  private calculate() {
    if (!this.date) return;

    const target = new Date(this.date);
    const today = new Date();
    target.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffTime = target.getTime() - today.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    // Overdue Logic
    // Only overdue if date is past AND status is NOT done/confirmed
    const isDone = this.completionStatus === 'done' || this.completionStatus === 'confirmed';
    this.isOverdue = diffDays < 0 && !isDone;

    // Badge Logic
    if (diffDays === 0) {
      this.dDayBadge = 'D-Day';
      this.dDayClass = 'bg-warning text-dark';
    } else if (diffDays > 0) {
      this.dDayBadge = `D-${diffDays}`;
      this.dDayClass = diffDays <= 3 ? 'bg-warning text-dark' : 'bg-info text-dark';
    } else {
      this.dDayBadge = `D+${Math.abs(diffDays)}`;
      this.dDayClass = 'bg-danger';
    }
  }
}
